const appEnvByMode = {
  staging: 'staging',
  production: 'production',
};

export const env = {
  appEnv: appEnvByMode[import.meta.env.MODE] ?? 'local',
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8080',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || undefined,
  commitSha: import.meta.env.VITE_COMMIT_SHA || undefined,
};

export const isProduction = env.appEnv === 'production';
